module.exports = __webpack_public_path__ + "img/botswana.17363279.svg";